var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconMarkerTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C7.812 0 4 3.9 4 8.696c0 3.448 2.052 7.427 4.067 10.6a52.968 52.968 0 004.035 5.52.53.53 0 00.398.184.53.53 0 00.398-.185s2.02-2.352 4.035-5.52C18.948 16.127 21 12.161 21 8.696 21 3.9 17.188 0 12.5 0zm0 1.087c4.113 0 7.438 3.401 7.438 7.61 0 3.01-1.933 6.925-3.902 10.02-1.652 2.595-3.046 4.304-3.536 4.892-.488-.588-1.882-2.305-3.536-4.908-1.97-3.1-3.902-7.015-3.902-10.005 0-4.208 3.325-7.609 7.438-7.609zM8.781 5.979v7.066h7.438V5.979H8.78zm1.063 1.087h5.312v4.892H9.844V7.066zm1.494 1.087a.544.544 0 00-.482.594c.027.3.289.52.582.493h2.124c.191.002.37-.1.467-.27a.56.56 0 000-.547.532.532 0 00-.466-.27H11.337z",
    stroke: "currentColor",
    strokeWidth: 0.25,
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

export default SvgCommonIconMarkerTracking;